module.exports = __webpack_public_path__ + "images/day-f649927a3a9530e1e896094efaad3b30.jpg";